import { Line } from '@cgs/data-access';
import {
  Action,
  EmptyAction,
  IntervalAction,
  ParallelAction,
  RepeatAction,
  SequenceAction,
} from '@cgs/wge';
import { SLOT_SESSION_TOKEN, SlotSession } from '../../../common/slot_session';
import { WinLineAction } from '../win_line_action';
import {
  ExpandedShortWinlinesAction,
  ExpandedShortWinlinesActionParams,
} from './expanded_short_winlines_action';

export class ExpandedWinlinesActions extends ExpandedShortWinlinesAction {
  protected readonly useSound: boolean;
  protected readonly slotSession: SlotSession;

  constructor(params: ExpandedShortWinlinesActionParams, useSound: boolean) {
    super(params);

    this.slotSession = this.container.resolve<SlotSession>(SLOT_SESSION_TOKEN);

    this.useSound = useSound;
  }

  //-------- PUBLIC -------
  public buildAction(): Action {
    const winlines = this._getSortedWinlinesByWinAmount();
    if (!winlines.length) {
      return new EmptyAction();
    }

    const result = winlines.map((line) => this.processWinline(line));
    return new RepeatAction(new SequenceAction(result));
  }

  //------- PRIVATE -------
  protected _getSortedWinlinesByWinAmount(): Line[] {
    const winLines = super.winLines.map((winLine) => {
      const modifiedWinLine = { ...winLine };
      modifiedWinLine.winAmount =
        winLine.winAmount * (winLine.multiplier ?? 1) * this.slotSession.currentBet.bet;

      return modifiedWinLine;
    });

    if (this.winPositions) {
      for (const winPos of this.winPositions) {
        const newWinLine = new Line();
        newWinLine.positions = winPos.positions;
        newWinLine.symbolId = winPos.symbolId;
        newWinLine.winAmount = winPos.win;
        winLines.push(newWinLine);
      }
    }

    winLines.sort((a, b) => {
      const win = b.winAmount - a.winAmount;
      if (win === 0) {
        // TODO: symbolId может быть равен null?
        if (a.symbolId! - b.symbolId! === 0) {
          if (typeof a.lineIndex === 'number' && typeof b.lineIndex === 'number') {
            return a.lineIndex - b.lineIndex;
          }
        }
        // TODO: symbolId может быть равен null?
        return a.symbolId! - b.symbolId!;
      }
      return win;
    });
    return winLines;
  }

  protected processWinline(winline: Line): IntervalAction {
    const delay = new EmptyAction().withDuration(0.2);

    return new SequenceAction([
      new ParallelAction([
        new WinLineAction(this.container, winline, this.useSound),
        this.lineDrawer?.drawWinlineAction(winline.lineIndex) || new EmptyAction(),
      ]),
      this.lineDrawer?.hideWinlineAction(winline.lineIndex) || new EmptyAction(),
      delay,
    ]);
  }
}
